export const usabillaConfig = {
  localeMap: {
    ar: 'Arabic',
    de: 'German',
    en: '',
    es: 'Spanish',
    fr: 'French',
    hu: 'Hungarian',
    id: 'Indonesian',
    it: 'Italian',
    ja: 'Japanese',
    kh: 'Khmer',
    ko: 'Korean',
    mn: 'Mongolian',
    nl: 'Dutch',
    no: 'Norwegian',
    pl: 'Polish',
    pt: 'Portuguese',
    ru: 'Russian',
    sm: 'Samoan',
    th: 'Thai',
    to: 'Tongan',
    vi: 'Vietnamese',
    zh: 'ChineseTraditional',
    'zh-hans': 'Chinese',
  },
  options: [
    // session
    {
      whiteList: [/\/session\/*/, /\/registered-session\/*/],
      form: '//w.usabilla.com/c9346265d7c9.js',
    },
    // default
    {
      form: '//w.usabilla.com/1810e28bb08e.js',
    },
  ],
}
